import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';
import sortedBy from 'util/sortedBy';

import {
  TaggedUnionUISchema,
  FIELD_ORDER_UI_SCHEMA_KEY,
  ShapeUISchema,
  HIDDEN_FIELDS_KEY,
} from '../StepConfigEditorTypes';

/** @package */
export default function getSortedSubfields(
  fields: Record<string, PipelineConfigJsonSpec>,
  uiSchema: TaggedUnionUISchema | ShapeUISchema | undefined
): Array<[string, PipelineConfigJsonSpec]> {
  const entries = Object.entries(fields).filter(
    ([key, value]) => uiSchema?.[HIDDEN_FIELDS_KEY] == null || !uiSchema[HIDDEN_FIELDS_KEY].includes(key)
  );
  const fieldOrder = uiSchema?.[FIELD_ORDER_UI_SCHEMA_KEY];
  if (fieldOrder == null) {
    return entries;
  }

  const variableNames = Object.keys(fields);

  return sortedBy(entries, [
    ([variableName]) => {
      const uiSchemaIndex = fieldOrder.indexOf(variableName);

      return uiSchemaIndex < 0
        ? // If the variable name is not in the UI schema, put it at the end by returning a value greater than
          // the length of the UI schema and relative to its original position.
          fieldOrder.length + variableNames.indexOf(variableName)
        : uiSchemaIndex;
    },
  ]);
}
